import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import About from '../components/page-components/about';

const AboutPageTemplateContainer = styled.div``;

const AboutPageTemplate = ({ data }) => {
    return (
        <Layout>
            <AboutPageTemplateContainer>
                <About data={data} />
            </AboutPageTemplateContainer>
        </Layout>
    );
};

export default AboutPageTemplate;

export const query = graphql`
    query($slug: String!) {
        allWpPage(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    id
                    title
                    slug
                    about_page_acf {
                        bannerHeadline
                        bannerCaption
                        pageColor
                        secondaryHeadline
                        contentRows {
                            bodyContent
                            title
                            image {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        nextPageButton {
                            title
                            url
                        }
                        waveTitle
                        waveCaption
                        waveButton {
                            title
                            url
                        }
                        bottomBannerImage {
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 1400) {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                            }
                        }
                        bottomBannerTitle
                        bottomBannerCaption
                    }
                }
            }
        }
    }
`;
